module.exports = __webpack_public_path__ + "static/banner-tablet-69d8d8b43685401a1c5142b9a7f4eba7.png";